import React, { useEffect, useState } from 'react';
import QuizTemplate from '../components/QuizTemplate';
import { useDispatch, useSelector } from 'react-redux';
import { RootDispatch, RootState } from '../store/Store';
import { useSearchParams, Link } from 'react-router-dom';
import { Quiz } from '../models/Quiz';
import { initializeFromQuiz } from '../store/QuizSlice';
import { usePageMeta } from '../hooks/usePageMeta';
import './QuizPage.css';

interface QuizPageProps { }

const QuizPage: React.FC<QuizPageProps> = () => {
    usePageMeta('Practice exam', 'Practice Danish citizenship or indfødsret exam with past official questions.');
    const dispatch = useDispatch<RootDispatch>();
    const quizzesData = useSelector((state: RootState) => state.quizzes.data);
    
    const [searchParams] = useSearchParams();
    const paramQuizId = searchParams.get('id');
    
    const [quiz, setQuiz] = useState<Quiz | null>(null);
    
    useEffect(() => {
        setQuiz(null);
        for(const q of quizzesData) {
            if (q.id === paramQuizId) {
                const randomizedQuiz = Quiz.randomizeQuiz(q);
                setQuiz(randomizedQuiz);
                dispatch(initializeFromQuiz(randomizedQuiz));
                return;
            }
        }
    }, [dispatch, paramQuizId, quizzesData]);

    return (
        <div className="quiz-page-container">
            <Link to="/projects/vejen-til-dansk-statsborgerskab" className="quiz-back-link">
                <span className="quiz-back-arrow">←</span>
                <span>🇩🇰 Vejen til Dansk Statsborgerskab</span>
            </Link>
            <QuizTemplate data={quiz} />
        </div>
    );
};

export default QuizPage;
